import { get } from 'react-hook-form';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';

import type { JSX } from 'react';

/**
 * テキストエリア基本コンポーネント
 */
export default function FormTextArea<TFieldValues extends FieldValues = FieldValues>(props: {
  // 項目名
  subject?: string;
  // name属性
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 最大文字数
  maxLength?: number;
  // 最小文字数
  minLength?: number;
  // 最小文字数
  className?: string;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // 行数
  rows?: number;

  errors: FieldErrors<TFieldValues>;
  register: UseFormRegister<TFieldValues>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  // 検証タイプの取得
  const type = get(props.errors, props.name)?.type ?? null;

  return (
    <>
      {props.subject && (
        <label className="form-label">
          {props.subject}
          {props.requiredMark && (
            <span className={props.required ? 'must' : 'any'}>{props.required ? ' *' : ''}</span>
          )}
        </label>
      )}

      <textarea
        className={get(props.errors, props.name) ? 'is-invalid form-control' : 'form-control'}
        rows={props.rows ? props.rows : 3}
        name={props.name}
        readOnly={props.readOnly ? true : false}
        placeholder={props.placeholder}
        {...props.register(props.name as Path<TFieldValues>, {
          required: props.required,
          maxLength: props.maxLength,
          minLength: props.minLength,
        })}
      />
      {get(props.errors, props.name) && (
        <p className="error">
          {type === 'required' && <>必須項目です。</>}
          {type === 'maxLength' && props.maxLength != props.minLength && (
            <>{props.maxLength}文字以内で入力してください。</>
          )}
          {type === 'minLength' && props.maxLength != props.minLength && (
            <>{props.minLength}文字以上で入力してください。</>
          )}
          {(type === 'maxLength' || type === 'minLength') &&
            props.maxLength === props.minLength && <>{props.minLength}文字で入力してください。</>}
          {get(props.errors, props.name)?.type === 'custom' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
        </p>
      )}
    </>
  );
}
